
  // Export
  module.exports =
  {

    // Search scripts
    search:
    {

      // Method-wide scripts
      _init: function ()
      {

        APPLICATION._APPLICATION.load($('#applications'), APPLICATION._PATH_PREFIX + 'application/applications', 'Application', 'applications')        

      }

    },

    // Applications scripts
    applications:
    {

      // Method-wide scripts
      _init: function ()
      {

        // Process the links
        APPLICATION._APPLICATION.processLinks('#applications', 'Application', 'applications')

        // On updating
        $('.js-update').not('.js-ignore').change(function ()
        {

          // The data
          var data = {}

          // The name
          var name = $(this).attr('name')

          // The value
          var value = $(this).val()

          // Add the data
          data[name] = value

          // The application ID
          var application_id = $(this).data(APPLICATION._DATA_PREFIX + 'application_id')

          // Post
          $.post(APPLICATION._PATH_PREFIX + 'application/update/' + application_id, data)

        }
        ).addClass('js-ignore')

        $('.site_complete').on('change', function () {

          if ($(this).is(':checked'))
          {

            // trigger modal popup with correct price etc. 
            APPLICATION._APPLICATION.customModal(
              APPLICATION._PATH_PREFIX + 'application/completeApplicationPopup?application_id=' + $(this).attr('data-application-id'), 
              'Application', 
              'completeApplicationPopup'
            )

          }

        })

      }

    },

    // Section 1 scripts
    section1:
    {

      setCOINS: function(brand) {
          $('.coins').each(function(i, e){
              var $this = $(this);
              $this.hide();
              $('[name="phase_number"]', this).prop('disabled', true)
              var brands  = $this.attr('data-coins-brand');
              console.log('BRAND: '+brand+' BRANDS: '+brands );
              if(typeof brands != 'undefined') {
                  brands = brands.split(',');
                  if(-1 !== brands.indexOf(brand)) {
                      // we have the right element
                      $this.show();
                      $('[name="phase_number"]', this).prop('disabled', false)
                  }
              }
          });
      },
      // Method-wide scripts
      _init: function ()
      {
        // set up the initial brand ID
        var brand = $('#brand_id').val();
        this.setCOINS(brand);

        $('#brownfield').not('.js-ignore').change(function ()
        {

          if ('1' === $(this).val())
          {
            $('#brownfield-wrapper').show()
          }

          else
          {
            $('#brownfield-wrapper').hide()
          }

        }).addClass('js-ignore').trigger('change')

        // On changing the enquiry type
        $('#enquiry_type_id').not('.js-ignore').change(function ()
        {

          // Determine the value
          switch ($(this).val())
          {

            // Additional phase
            case '3':
  
              // Set the label
              $('#development_name_label').text('Or enter the development name')

              // Show the dropdown
              $('#development_id_wrapper, #development_name_wrapper, #phase_number_wrapper, #previous_fibrenest_wrapper').show()

              // Hide marketing name
              $('#marketing_name_wrapper').hide()

              // Hide marketing url
              $('marketing_url_wrapper').hide()

              // Break
              break

            // Multi phase
            case '2':

              // Set the label
              $('#development_name_label').text('Development name')

              // Hide the dropdown
              $('#development_id_wrapper, #previous_fibrenest_wrapper').hide()
  
              // Show the name
              $('#development_name_wrapper, #phase_number_wrapper, #marketing_name_wrapper, #marketing_url_wrapper').show()

              // Break
              break

            // One phase
            case '1':

              // Set the label
              $('#development_name_label').text('Development name')

              // Hide the dropdown
              $('#development_id_wrapper, #previous_fibrenest_wrapper').hide()
  
              // Show the name
              $('#development_name_wrapper, #marketing_name_wrapper, #marketing_url_wrapper').show()

              // Hide the phase number
              $('#phase_number_wrapper').hide() 

              // Break
              break

            // Default
            default:
              $('#development_id_wrapper, #development_name_wrapper, #phase_number_wrapper, #previous_fibrenest_wrapper').hide()

          }

        }
        ).addClass('js-ignore').trigger('change')

        // Get the development dropdown
        var development = $('#development_id')

        var THIS = this;

              // On changing the brand or company
        $('#brand_id, #company_id').not('.js-ignore').change(function ()
        {
          // Get the brand ID
          var brand_id = $('#brand_id').val()

          // Get the company ID
          var company_id = $('#company_id').val()

          // If no brand or company
          if ('' === brand_id || '' === company_id)
          {
            development.next('.dropdown-menu').html('')
          }

          // Otherwise
          else
          {
            // switch on brand name for COINS number
            THIS.setCOINS(brand_id);

            // now set the COINS cod hidden field
            APPLICATION._APPLICATION.loadDropdown(development, APPLICATION._PATH_PREFIX + 'development/dropdown/' + company_id + '/' + brand_id + '?has_multiple_phases=1&development_id=' + development.val(), 'Development', 'dropdown')
          }
        }
        ).addClass('js-ignore')

        // On changing the development name
        $('#development_name').not('.js-ignore').change(function ()
        {

          // If not empty
          if ('' !== $(this).val().trim())
          {

            // Remove dropdown selection
            $('#development_id').val('').trigger('change').next().val('')

            // Remove highlight
            $('li.active', $('#development_id').parent()).removeClass('active')

          }

        }
        ).addClass('.js-ignore').trigger('change')

        // On changing the development ID
        development.not('.js-ignore').change(function ()
        {

          // If not empty
          if ('' !== $(this).val().trim())
          {
            $('#development_name').val('')
          }

        }
        ).addClass('.js-ignore')

        // On changing the previous FibreNest status
        $('#previous_fibrenest').not('.js-ignore').change(function ()
        {

          // If no
          if ('0' === $(this).val())
          {
            $('#service_wrapper, #service_type_wrapper').show()
          }

          // Otherwise
          else
          {
            $('#service_wrapper, #service_type_wrapper').hide()
          }

        }
        ).addClass('js-ignore').trigger('change')

        // On changing the site complete
        $('.site_complete').not('.js-ignore').change(function ()
        {

          $(this).val(this.checked?1:0)

        })

      }

    },

    // Section 2 scripts
    section2:
    {

      // The map
      _map: null,

      // Method-wide scripts
      _init: function ()
      {

        // Get the script
        $.getScript('https://maps.googleapis.com/maps/api/js?key=' + APPLICATION._GOOGLEMAPS_API_KEY, function ()
        {
          APPLICATION.Application.section2.initMap()
        }
        )

      },

      // Initialize the map
      initMap: function ()
      {

        // Create the map
        APPLICATION.Application.section2._map = new google.maps.Map(document.getElementById('map'),
        {
          center: new google.maps.LatLng(54.093409, -2.89479),
          mapTypeId: google.maps.MapTypeId.TERRAIN,
          zoom: 6,
          gestureHandling: 'cooperative',
        }
        )

        // Set the marker
        APPLICATION.Application.section2.setMarker()

        // The Geocoder
        var geocoder = new google.maps.Geocoder();

        // On clicking the map
        google.maps.event.addListener(APPLICATION.Application.section2._map, 'click', function (event)
        {

          // Set the latitude
          $('#latitude').val(event.latLng.lat())

          // Set the longitude
          $('#longitude').val(event.latLng.lng())

          // Set the marker
          APPLICATION.Application.section2.setMarker()

          // Get the address
          geocoder.geocode(
          {
            'latLng': event.latLng
          }, function (results, status)
          {

            // If a success
            if (google.maps.GeocoderStatus.OK == status)
            {

              // If results
              if (results[0])
              {

                // Reset the address
                $('#address_1, #address_2, #town, #postcode').val('')

                // The parts
                var parts = ['route', 'locality', 'postal_town', 'postal_code']

                // The IDs
                var ids = ['address_1', 'town', 'town', 'postcode']

                // Iterate over the parts
                for (var i = 0; i < parts.length; ++i)
                {

                  // Iterate over the address components
                  for (var n = 0; n < results[0].address_components.length; ++n)
                  {

                    // If a part
                    if (-1 !== results[0].address_components[n].types.indexOf(parts[i]))
                    {
                      $('#' + ids[i]).val(results[0].address_components[n].long_name)
                    }

                  }

                }

              }

            }

          }
          )

        }
        )

      },

      // Set the marker
      setMarker: function ()
      {
  
        // Get the map
        var map = APPLICATION.Application.section2._map

        // If a map
        if (null !== map)
        {

          // Get the marker
          var marker = map._marker

          // If a marker
          if (undefined !== marker)
          {

            // Remove the marker
            marker.setMap(null)

            // Destroy the marker
            marker = null

            // Delete the marker
            delete map._marker

          }

          // Get the latitude
          var latitude = parseFloat($('#latitude').val())

          // Get the longitude
          var longitude = parseFloat($('#longitude').val())

          // If coordinates
          if (isFinite(latitude) && isFinite(longitude))
          {

            // Create the marker
            map._marker = new google.maps.Marker(
            {
              map: map,
              position: new google.maps.LatLng(latitude, longitude),
            }
            )

          }

        }

      }

    },

    // Section 3 scripts
    section3:
    {

      // Method-wide scripts
      _init: function ()
      {

        // On changing the number of apartment blocks
        $('#apartment_blocks').not('.js-ignore').keyup(function ()
        {

          // If apartment blocks
          if (parseInt($(this).val(), 10) > 0)
          {
            $('#flats_wrapper').show()
          }

          // Otherwise
          else
          {
            $('#flats_wrapper').hide()
          }

        }
        ).addClass('js-ignore').trigger('keyup')

        // On changing the phase type
        $('#phase_type_id').not('.js-ignore').change(function ()
        {

          // Determine the value
          switch ($(this).val())
          {

            // Commercial
            case '3':

              // Show building types
              $('#building_types_wrapper').show()
  
              // Hide houses, blocks, and flats
              $('#houses_wrapper, #apartment_blocks_wrapper, #flats_wrapper').hide()

              // Break
              break

            // Residential and commercial
            case '2':

              // Show building types, houses, and blocks
              $('#building_types_wrapper, #houses_wrapper, #apartment_blocks_wrapper').show()
  
              // Trigger change of apartment blocks
              $('#apartment_blocks').trigger('keyup')

              // Break
              break

            // Residential
            case '1':

              // Hide building types
              $('#building_types_wrapper').hide()

              // Show houses and blocks
              $('#houses_wrapper, #apartment_blocks_wrapper').show()
  
              // Trigger change of apartment blocks
              $('#apartment_blocks').trigger('keyup')

              // Break
              break

            // Default
            default:

              // Hide building types, houses, blocks, and flats
              $('#building_types_wrapper, #houses_wrapper, #apartment_blocks_wrapper, #flats_wrapper').hide()

          }

        }
        ).addClass('js-ignore').trigger('change')

        $('#s278').not('.js-ignore').change(function ()
        {
            // If yes
            if ('1' === $(this).val())
            {
                $('#s278_description_wrapper').show()
            }

            // Otherwise
            else
            {
                $('#s278_description_wrapper').hide()
            }
        }).addClass('js-ignore').trigger('change');

        // On changing the nearby properties status
        $('#nearby_properties').not('.js-ignore').change(function ()
        {

          // If yes
          if ('1' === $(this).val())
          {
            $('#nearby_plots_wrapper').show()
          }

          // Otherwise
          else
          {
            $('#nearby_plots_wrapper').hide()
          }

        }
        ).addClass('js-ignore').trigger('change')

      },

      // On changing building type
      changeBuildingType: function (input)
      {

        // Get the row
        var row = input.closest('.row-item')

        // If not empty
        if ('0' !== input.val())
        {
          $('.js-building_type_name', row).hide()
        }

        // Otherwise
        else
        {
          $('.js-building_type_name', row).show()
        }

      },

      addRow: function (row)
      {

        // Add the row
        var clone = APPLICATION._APPLICATION.addRow(row)

        // Hide the building name
        $('.js-building_type_name', clone).hide()

      }

    },

    // Section 4 scripts
    section4:
    {

      // Method-wide scripts
      _init: function ()
      {

        // On changing plot rate
        $('#plot_rate').not('.js-ignore').keyup(function ()
        {

          // Get the rate
          var rate = parseInt($(this).val().replace(/\D/g, '') || 0, 10)

          // If greater than 9
          if (rate > 8)
          {

            // Set the rate
            $('#plot_rate_label').text(rate)

            // Show the wrapper
            $('#confirm_plot_rate_wrapper').show()

          }

          // Otherwise
          else
          {
            $('#confirm_plot_rate_wrapper').hide()
          }

        }
        ).addClass('js-ignore').trigger('keyup')

      }

    },

    // Section 5 scripts
    section5:
    {

      // Method-wide scripts
      _init: function ()
      {

        // On changing the planning status
        $('#planning_status_id').not('.js-ignore').change(function ()
        {

          // Determine the value
          switch ($(this).val())
          {

            // Detailed
            case '1':

              // Show dates
              $('#actual_outline_date_wrapper, #actual_detailed_date_wrapper, #reference_wrapper').show()

              // Hide dates
              $('#estimated_outline_date_wrapper, #estimated_detailed_date_wrapper').hide()

              // Change the reference label
              $('#reference_label').text('')

              // Break
              break

            // Outline
            case '2':

              // Show dates
              $('#actual_outline_date_wrapper, #estimated_detailed_date_wrapper, #reference_wrapper').show()

              // Hide dates
              $('#estimated_outline_date_wrapper, #actual_detailed_date_wrapper').hide()

              // Change the reference label
              $('#reference_label').text('(if known)')

              // Break
              break

            // Not submitted
            case '3':

              // Show dates
              $('#estimated_outline_date_wrapper, #estimated_detailed_date_wrapper').show()

              // Hide dates
              $('#actual_outline_date_wrapper, #actual_detailed_date_wrapper, #reference_wrapper').hide()

              // Change the reference label
              $('#reference_label').text('(if known)')

              // Break
              break

            // Submitted
            case '4':

              // Show dates
              $('#estimated_outline_date_wrapper, #estimated_detailed_date_wrapper, #reference_wrapper').show()

              // Hide dates
              $('#actual_outline_date_wrapper, #actual_detailed_date_wrapper').hide()

              // Change the reference label
              $('#reference_label').text('(if known)')

              // Break
              break

            // Default
            default:

              // Hide dates
              $('#estimated_outline_date_wrapper, #actual_outline_date_wrapper, #estimated_detailed_date_wrapper, #actual_detailed_date_wrapper, #reference_wrapper').hide()

              // Change the reference label
              $('#reference_label').text('')

          }

        }
        ).addClass('js-ignore').trigger('change')

        // On changing the Wayleave requirement
        $('#require_wayleave_consent').not('.js-ignore').change(function ()
        {

          // If yes
          if ('1' === $(this).val())
          {
            $('#wg_wrapper').show()
          }

          // Otherwise
          else
          {
            $('#wg_wrapper').hide()
          }

        }
        ).addClass('js-ignore').trigger('change')

        // On changing the land purchased
        $('#land_purchased').not('.js-ignore').change(function ()
        {

          // If no
          if ('0' === $(this).val())
          {
            $('#land_purchase_date_wrapper').show()
          }

          // Otherwise
          else
          {
            $('#land_purchase_date_wrapper').hide()
          }

        }
        ).addClass('js-ignore').trigger('change')

      },

    },

    // View scripts
    view:
    {

      // Method-wide scripts
      _init: function ()
      {

        // Get the script
        $.getScript('https://maps.googleapis.com/maps/api/js?key=' + APPLICATION._GOOGLEMAPS_API_KEY, function ()
        {
          APPLICATION.Application.view.initMap()
        }
        )
        
        //defined in \Views\Application\view.php
        if (window.marketing_name)
        {
          APPLICATION._APPLICATION.customModal(APPLICATION._PATH_PREFIX + 'application/marketing-name/' + application_id , 'Application', 'marketingName')
        }
        

      },

      // Initialize the map
      initMap: function ()
      {

        // Get the latitude
        var latitude = parseFloat($('#latitude').val())

        // Get the longitude
        var longitude = parseFloat($('#longitude').val())

        // Create the map
        var map = new google.maps.Map(document.getElementById('map'),
        {
          center: new google.maps.LatLng(latitude, longitude),
          mapTypeId: google.maps.MapTypeId.TERRAIN,
          zoom: 8,
          gestureHandling: 'cooperative',
        }
        )
  
        // Create the marker
        new google.maps.Marker(
        {
          map: map,
          position: new google.maps.LatLng(latitude, longitude),
        }
        )

      }

    },

    cabinet:
    {
      // Method-wide scripts
      _init: function ()
      {
        $('#add-note').not('.js-ignore').on('click', function(){

          return false;
        }).addClass('js-ignore');

        $('body').on('modal:close', function(ev, controller, event){

          $('body').removeClass('show-modal');

          if(controller == 'Application' && event == 'cabinetNote') {
            // get the notes
            var cab = $('#notes-wrap').attr('data-application');
            $('#notes-wrap').load(APPLICATION._PATH_PREFIX+'application/cabinet-notes/'+cab);
          }

        });

      },
    },

    backhaul:
    {
      _init: function ()
      {

        $('#set-pickup').not('.js-ignore').click(function ()
        {

          // Get the geolocation
          navigator.geolocation.getCurrentPosition(function (position)
          {
  
            var latitude = position.coords.latitude
  
            var longitude = position.coords.longitude
  
            $('#pickup_latitude').val(latitude)
  
            $('#pickup_longitude').val(longitude)
  
            $.ajax(APPLICATION._PATH_PREFIX + 'application/bng/' + latitude + '/' + longitude,
            {
  
              success: function (response)
              {
  
                data = JSON.parse(response)
  
                if ('object' === typeof data && 2 === data.length)
                {
  
                  $('#pickup_easting').val(data[0])
      
                  $('#pickup_northing').val(data[1])
  
                }
  
              }
  
            }
            )
  
          }
          )

        }
        ).addClass('.js-ignore')

        $('body').on('modal:close', function(ev, controller, event){
          $('body').removeClass('show-modal');

          if(controller == 'Application' && event == 'backhaulNote') {
            // get the notes
            var backhaul = $('#notes-wrap').attr('data-application');
            $('#notes-wrap').load(APPLICATION._PATH_PREFIX+'application/backhaul-notes/'+backhaul);
          }
        });
        
        $('#backhaul_type_id').on('change',function() {
          
          if ($(this).val() == 2)
          {
            development = $('#backhaul_feed_from').val();
            company_id = $('#company_id').val();
            
            APPLICATION._APPLICATION.loadDropdown($('#backhaul_feed_form').parent(),APPLICATION._PATH_PREFIX + 'development/dropdown/' + company_id + '?development_id='+development,'development','Dropdown');
            //reveal development dropdown
            $('#backhaul_feed_from').closest('.form-group').removeClass('hide');
          } else
          {
            if (!$('#backhaul_feed_from').closest('.form-group').hasClass('hide'))
            {
              $('#backhaul_feed_from').closest('.form-group').addClass('hide');
            }
          }
        })

        type = $('#backhaul_type_id').val(); 
        
        feed_parent = $('#backhaul_feed_from').closest('.form-group');
        if (2 == type)
        {
          development = $('#backhaul_feed_from').val();
          company_id = $('#company_id').val();
          //
          APPLICATION._APPLICATION.loadDropdown($('#backhaul_feed_form').parent(),APPLICATION._PATH_PREFIX + 'development/dropdown/' + company_id + '?development_id='+development,'development','Dropdown');
          feed_parent.removeClass('hide');
          } else
          {
            if (!feed_parent.hasClass('hide'))
            {
              feed_parent.addClass('hide');
            }
          }
          
      }
    },

    // Check up edit scripts
    checkUpEdit:
    {

      // Method-wide scripts
      _init: function ()
      {
  
        // On clicking the calendar
        $('#service_date_calendar, #sales_office_date_calendar').not('.js-ignore').click(function ()
        {
  
          // Get the form
          var form = $(this).closest('form').serialize()
  
          // Get the application ID
          var application_id = $(this).closest('form').attr('data-' + APPLICATION._DATA_PREFIX + 'application_id')

          // Get the input
          var input = $(this).attr('for')
  
          // Store the datepicker
          APPLICATION._datepicker = function (date)
          {
  
            // Set the due date
            form += '&' + input  + '=' + date
  
            // Show the custom modal
            APPLICATION._APPLICATION.customModal(APPLICATION._PATH_PREFIX + 'application/check-up-edit/' + application_id + '?' + form, 'Application', 'checkUpEdit')
  
          }
  
          // Get the parts
          var parts = $('#' + input).val().split('/')
  
          // Open the calendar
          APPLICATION._APPLICATION.customModal(APPLICATION._PATH_PREFIX + 'calendar/month/' + parts[2] + '/' + parts[1] + '?modal=1&date=' + parts[2] + '-' + parts[1] + '-' + parts[0], 'Calendar', 'month')  

        }
        ).addClass('js-ignore')

      }

    }

  }